import Emitter from "es6-event-emitter";
import alb from "./../../templates/albController.dust"; // eslint-disable-next-line
import enrichmentButton from "./../../templates/enrichmentButton.dust"; // this is needed!
import FontSizeService from "./../fontSizeService";
import AlbPage from "./albPage";
import SharingController from "./../sharingController";
import URLRouter from "./../../utilities/URLRouter";
import {
  CLICKAWAY_OVERLAY_ALB,
  CLICKED_BACK_ALB,
  CLICKED_ENRICHEMENT_ALB,
  CLICKED_FONT_ALB,
  CLICKED_NEXT_ALB,
  CLICKED_PREV_ALB,
  CLICKED_SHARE_ALB,
  CLOSED_ALB,
  CLOSED_SHARE_MENU_ALB,
  OPENED_ALB,
  SWIPED_BACKWARD_ALB,
  SWIPED_FORWARD_ALB,
  VIEW_ARTICLE_ALB,
} from "./../../analytics/analyticsevents";
export default class ArticleLightBoxController extends Emitter {
  appState = null;
  data = null;
  options = null;
  isSinglepage = true;
  DOMContainer = null;

  albPages = [];

  removeDoubles = true;

  currentContentIDs = [];

  navigated = false;

  lastIndex = null;

  fontSizeService = null;

  constructor(appState, data, options) {
    super();
    this.appState = appState;
    this.data = data;
    this.options = options;
    this.isSinglepage = this.data[0].length === 1;
    this.DOMContainer = document.querySelector("#alb");

    if (this.appState.analyticsManager.cmpManager) {
      this.appState.analyticsManager.cmpManager.on(
        "userConsent:changed",
        () => {
          if (URLRouter.isAlbURL()) {
            this.appState.triggerEvent(VIEW_ARTICLE_ALB);
          }
        }
      );
    }
  }

  createContext() {
    const context = [];
    context.extraButton = this.options.extraButtonOnSlider;
    context.tablet = this.appState.isTablet || this.appState.isDesktop;
    return context;
  }

  render() {
    if (this.DOMContainer !== null) {
      Dust.render(alb, this.createContext(), (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.initFontSize();
        this.createSwiper();
        this.attachClickHandlers();
        this._toggleSwiperKeyboardControl();
        if (this.appState.contentid) {
          this.goTo(this.appState.currentPage, this.appState.contentid);
        }
      });
    }
  }

  createSwiper() {
    this.swiper = new Swiper("#alb .swiper-container-alb", {
      keyboardControl: true,
      simulateTouch: false,
      onTransitionEnd: () => {
        this.afterSlideChange();
      },
    });
  }

  initFontSize() {
    if (this.options.increaseFontSizeEnabled) {
      const fontSize = this.DOMContainer.querySelector(".alb-nav-size");
      if (fontSize) {
        this.fontSizeService = new FontSizeService(
          this.options.fontSizeService
        );
        fontSize.classList.remove("novisibility");
      }
    }
  }

  attachClickHandlers() {
    $(document).on("keydown", (e) => {
      if (this.DOMContainer) {
        const $activeSlideEl = $(
          this.DOMContainer.querySelector(
            "#alb .swiper-slide-active .alb-content-scroll"
          )
        );
        if (!$activeSlideEl) return;
        if (e.which === 40) {
          // down
          $activeSlideEl.focus();
        } else if (e.which === 38) {
          // up
          $activeSlideEl.focus();
        }
      }
    });
    const back = this.DOMContainer.querySelector(".alb-nav-back");
    if (back) {
      back.addEventListener("click", this.back);
    }
    if (this.options.increaseFontSizeEnabled) {
      const font = this.DOMContainer.querySelector(".alb-nav-size");
      if (font) {
        font.addEventListener("click", this.font);
      }
    }
    const prev = this.DOMContainer.querySelector(".alb-nav-previous");
    if (prev) {
      prev.addEventListener("click", this.slideToPrev);
    }
    const next = this.DOMContainer.querySelector(".alb-nav-next");
    if (next) {
      next.addEventListener("click", this.slideToNext);
    }
    if (this.options.extraButtonOnSlider) {
      const button = this.DOMContainer.querySelector(
        ".alb-overall-extra-button-container"
      );
      if (button) {
        button.addEventListener("click", this.extraButtonClicked);
      }
    }
    if (this.options.sharingEnabled) {
      const share = this.DOMContainer.querySelector(".alb-nav-share");
      if (share) {
        share.addEventListener("click", this.shareClicked);
      }
    }

    //if clicked outside alb on overlay -> go out of alb
    const overlay = this.DOMContainer.querySelector(".alb-container");
    if (overlay) {
      overlay.addEventListener("click", this.onOverlayClicked);
    }

    this.appState.on("appState:contentIdChanged", this.setContentId);
    if (this.appState.analyticsManager.cmpManager) {
      this.appState.analyticsManager.cmpManager.on(
        "userConsent:changed",
        this.updateSharing
      );
    }
  }

  onOverlayClicked = (e) => {
    if (e.target === e.currentTarget) {
      this.hide();
      this.appState.triggerEvent(CLICKAWAY_OVERLAY_ALB);
      this.appState.trigger("alb:overlayClicked");
    }
  };

  closeSharing = (e, force) => {
    if (this.sharingController) {
      if (this.sharingController.close(e, force)) {
        const share = this.DOMContainer.querySelector(".alb-nav-share");
        if (share && share.classList.contains("open")) {
          share.classList.remove("open");
          this.appState.triggerEvent(CLOSED_SHARE_MENU_ALB);
        }
        this.DOMContainer.removeEventListener("click", this.closeSharing);
      }
    }
  };

  shareClicked = (e) => {
    const share = e.currentTarget;
    const sharingContainer = this.DOMContainer.querySelector(
      ".alb-nav-share .sharing-container"
    );
    if (sharingContainer) {
      if (sharingContainer.classList.contains("hidden")) {
        const albSlide = this.getCurrentAlbSlide();
        const showSharing = this.showSocialSharing();
        this.sharingController = new SharingController(
          this.appState,
          albSlide,
          sharingContainer,
          this.options.sharing,
          showSharing
        );
        if (share) {
          share.classList.add("open");
          e.stopPropagation();
          this.DOMContainer.addEventListener("click", this.closeSharing);
        }
      }
      if (
        e.target !== sharingContainer &&
        !sharingContainer.contains(e.target)
      ) {
        this.appState.triggerEvent(CLICKED_SHARE_ALB);
      }
    }
  };

  back = () => {
    this.hide();
    this.appState.triggerEvent(CLICKED_BACK_ALB);
  };

  font = () => {
    this.fontSizeService.increase();
    this.appState.triggerEvent(CLICKED_FONT_ALB);
  };

  slideToPrev = () => {
    this.navigated = true;
    this.swiper.slidePrev();
    this.appState.triggerEvent(CLICKED_PREV_ALB);
  };

  slideToNext = () => {
    this.navigated = true;
    this.swiper.slideNext();
    this.appState.triggerEvent(CLICKED_NEXT_ALB);
  };

  extraButtonClicked = () => {
    const albSlide = this.getCurrentAlbSlide();
    albSlide.scrollExtrasInView();
    this.appState.triggerEvent(CLICKED_ENRICHEMENT_ALB);
  };

  getSlideIndexOfCurrentSlide() {
    return $(this.swiper.slides[this.swiper.activeIndex]).data("sliden");
  }

  setContentId = () => {
    this.goTo(this.appState.currentPage, this.appState.contentid);
  };

  _goToAddSlide(index, contentid) {
    this.swiper.removeAllSlides();
    const promise = new Promise((resolve, reject) => {
      this.addPage(index, true)
        .then(() => {
          for (let i = 0; i < this.swiper.slides.length; i++) {
            if (
              this.swiper.slides[i].getAttribute("data-contentid") ===
              String(contentid)
            ) {
              this.show();
              this.swiper.update(); //otherwise it doesnt open correct one
              if (this.swiper.activeIndex !== i) {
                this.swiper.slideTo(i, 0);
              } else {
                this.afterSlideChange();
              }
              resolve(true); // ab slide is visible
            }
          }
          reject(false);
        })
        .catch(() => {
          reject(false);
        });
    });
    return promise;
  }

  goTo(page, contentid) {
    if (!contentid) {
      this.hide();
      return; //no cententid -> close alb
    }
    if (this.appState.articleLightBoxDisplayed) {
      for (let i = 0; i < this.swiper.slides.length; i++) {
        if (
          this.swiper.slides[i].getAttribute("data-contentid") ===
          String(contentid)
        ) {
          if (this.swiper.activeIndex !== i) {
            this.swiper.slideTo(i);
          }
          return; // ab slide is visible
        }
      }
      //TODO: case that alb is open but no correct id
    } else {
      let index = page;
      if (!this.isSinglepage) {
        index = Math.round(index / 2);
      }
      this._goToAddSlide(index, contentid)
        .then(() => {
          //ok
        })
        .catch(() => {
          this._goToAddSlide(index + 1, contentid)
            .then(() => {
              //try next slide
              //ok
            })
            .catch(() => {
              this._goToAddSlide(index - 1, contentid)
                .then(() => {
                  //try previous slide
                  //ok
                })
                .catch(() => {
                  // no content id in first page
                  this.appState.contentid = undefined;
                  this.hide();
                });
            });
        });
    }
  }

  open(data) {
    this.addPage(data.slideIndex, true).then(() => {
      let currentSlide = 0;
      const slides = this.swiper.slides;
      const length = slides.length;
      for (let i = 0; i < length; i++) {
        const slide = $(slides[i]);
        if (String(slide.data("contentid")) === data.contentID) {
          currentSlide = i;
        }
      }
      this.show();
      this.swiper.update(); //otherwise it doesnt open correct one
      if (this.swiper.activeIndex === currentSlide) {
        this.afterSlideChange();
      } else {
        this.swiper.slideTo(currentSlide, 0);
      }
      if (data.scrollToExtra) {
        const albSlide = this.getCurrentAlbSlide();
        albSlide.scrollExtrasInView();
      }
    });
  }

  addPage(pageNumber, append) {
    const promise = new Promise((resolve, reject) => {
      if (!this.albPages[pageNumber]) {
        if (this.data[pageNumber]) {
          const albPage = new AlbPage(
            this.appState,
            this.data[pageNumber],
            pageNumber,
            this.options.albslide
          );
          albPage.on("albPage:hideExtraButton", () => {
            this.hideExtraButton();
          });
          albPage.on("albPage:showExtraButton", () => {
            this.showExtraButton();
          });
          this.albPages[pageNumber] = albPage;
          albPage
            .render()
            .then(() => {
              this.addPageToSlider(pageNumber, append)
                .then(() => {
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            })
            .catch(() => {
              let newPageNumber = pageNumber;
              if (append) {
                newPageNumber++;
              } else {
                newPageNumber--;
              }
              this.addPage(newPageNumber, append)
                .then(() => {
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            });
        } else {
          reject(false); //end
        }
      } else {
        this.addPageToSlider(pageNumber, append)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      }
    });

    return promise;
  }

  addPageToSlider(pageNumber, append) {
    const promise = new Promise((resolve, reject) => {
      if (!this.addAlbPage(this.albPages[pageNumber], append)) {
        let index = pageNumber;
        if (append) {
          index++;
        } else {
          index--;
        }
        this.addPage(index, append)
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      } else {
        resolve();
      }
    });
    return promise;
  }

  addAlbPage(albPage, append) {
    let slidesAdded = false;
    const albSlides = albPage.getAllAlbSlides();
    if (!append) {
      albSlides.reverse();
    }
    for (let i = 0; i < albSlides.length; i++) {
      const albSlide = albSlides[i];
      if (this.currentContentIDs.indexOf(String(albSlide.contentID)) === -1) {
        this.currentContentIDs.push(
          albSlide.slide.getAttribute("data-contentid")
        );
        if (append) {
          this.swiper.appendSlide(albSlide.slide);
        } else {
          this.swiper.prependSlide(albSlide.slide);
        }
        albSlide.onAddedToAlb();
        slidesAdded = true;
      }
    }
    this.swiper.update();
    return slidesAdded;
  }

  setCurrentPage() {
    const promise = new Promise((resolve, reject) => {
      const currentPage = this.getCurrentPage();
      if (currentPage >= 0 && this.appState.currentPage !== currentPage) {
        this.appState
          .changeCurrentPage(currentPage, false, true)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      } else {
        resolve(true);
      }
    });
    return promise;
  }

  getCurrentPage() {
    const slide = this.swiper.slides[this.swiper.activeIndex];

    const slideN = $(slide).data("sliden");

    let currentPage = 0;
    if (this.isSinglepage) {
      currentPage = slideN;
    } else {
      const pageN = $(slide).data("pagen");
      currentPage = slideN * 2 + (pageN - 1);
    }
    if (currentPage < 0 || !currentPage) {
      currentPage = 0;
    }

    return currentPage;
  }

  afterSlideChange() {
    if (!this.swiper || this.DOMContainer.classList.contains("hidden")) {
      return;
    }

    this.closeSharing(null, true);

    if (this.swiper.activeIndex === this.lastIndex) {
      return;
    }

    if (!this.navigated && this.lastIndex !== null) {
      //no navigation event and should allready be a lastIndex (otherwise first) //else a navigation event is allready triggered
      if (this.lastIndex < this.swiper.activeIndex) {
        this.appState.triggerEvent(SWIPED_FORWARD_ALB);
      } else {
        this.appState.triggerEvent(SWIPED_BACKWARD_ALB);
      }
    }

    this.setCurrentPage().then(() => {
      this.activateNavigation();

      this.updateSlide();

      this.setCurrentArticle();

      const slide = this.swiper.slides[this.swiper.activeIndex];

      if ($(slide).data("contentid") === this.appState.contentid) {
        const activeIndex = this.swiper.activeIndex;
        const lengt = this.swiper.slides.length;

        if (activeIndex === 0 && activeIndex === lengt - 1) {
          this.onReachBeginning();
          this.onReachEnd();
        } else if (activeIndex === 0) {
          this.cleanupEnd();
          this.onReachBeginning();
        } else if (activeIndex === lengt - 1) {
          this.cleanupFront();
          this.onReachEnd();
        }
        this.appState.triggerEvent(VIEW_ARTICLE_ALB);
      }
    });
  }

  setCurrentArticle() {
    const slide = this.swiper.slides[this.swiper.activeIndex];

    const slideN = $(slide).data("sliden");
    const pageN = $(slide).data("pagen");
    const articleN = $(slide).data("articlen");

    const page = this.data[slideN][pageN];
    const article = page.content[articleN];
    this.appState.contentid = $(slide).data("contentid");
    this.appState.setActiveArticle(page, article);
  }

  hideExtraButton() {
    const button = this.DOMContainer.querySelector(
      ".alb-overall-extra-button-container"
    );
    if (button) {
      button.classList.add("hidden");
    }
  }

  showExtraButton() {
    const button = this.DOMContainer.querySelector(
      ".alb-overall-extra-button-container"
    );
    if (button) {
      button.classList.remove("hidden");
    }
  }

  getCurrentAlbSlide() {
    const slide = this.swiper.slides[this.swiper.activeIndex];

    const slideN = $(slide).data("sliden");
    const pageN = $(slide).data("pagen");
    const articleN = $(slide).data("articlen");

    const albPage = this.albPages[slideN];
    const albSlide = albPage ? albPage.albSlides[pageN][articleN] : null;

    return albSlide;
  }

  activateSharing(printIcon) {
    const sharing = this.DOMContainer.querySelector(".alb-nav-share");
    if (sharing) {
      if (printIcon) {
        sharing.classList.add("print");
      } else {
        sharing.classList.remove("print");
      }
      sharing.classList.remove("novisibility");
    }
  }

  inActivateSharing() {
    const sharing = this.DOMContainer.querySelector(".alb-nav-share");
    if (sharing) {
      sharing.classList.add("novisibility");
    }
  }

  updateSlide() {
    const albSlide = this.getCurrentAlbSlide();
    albSlide.update();

    this.updateSharing();

    if (this.options.extraButtonOnSlider) {
      const button = this.DOMContainer.querySelector(
        ".alb-overall-extra-button-container"
      );
      if (button) {
        if (albSlide.hasExtras()) {
          const numberContainer = button.querySelector(
            ".enrichment-number-container .enrichment-number"
          );
          if (numberContainer) {
            numberContainer.innerHTML = albSlide.getNumberOfExtras();
          }
          const extraType = button.querySelector(".enrichment-type");
          if (extraType) {
            extraType.dataset.type = albSlide.getExtraType();
          }
          button.classList.remove("hidden");
          albSlide.onScroll();
        } else {
          button.classList.add("hidden");
        }
      }
    }
  }

  updateSharing = () => {
    if (this.appState && this.appState.analyticsManager._options.cmp) {
      if (
        this.appState.analyticsManager.cmpManager &&
        this.appState.analyticsManager.cmpManager.isSocialSharingTrackingEnabled()
      ) {
        this.showSharingIcon();
      } else {
        if (this.options.printArticle) {
          this.activateSharing(true);
        } else {
          this.inActivateSharing();
        }
      }
    } else {
      this.showSharingIcon();
    }
  };

  showSharingIcon() {
    const albSlide = this.getCurrentAlbSlide();
    if (albSlide) {
      if (
        (this.options.shareFromReader && this.appState._sharingUrl) ||
        (this.options.sharingEnabled && albSlide.getSharingLink())
      ) {
        this.activateSharing();
      } else if (this.options.printArticle) {
        this.activateSharing(true);
      } else {
        this.inActivateSharing();
      }
    }
  }

  activateNavigation() {
    const next = this.DOMContainer.querySelector(".alb-nav-next");
    if (next) {
      next.classList.remove("inactive");
    }
    const previous = this.DOMContainer.querySelector(".alb-nav-previous");
    if (previous) {
      previous.classList.remove("inactive");
    }
  }

  inactivateNext() {
    const next = this.DOMContainer.querySelector(".alb-nav-next");
    if (next) {
      next.classList.add("inactive");
    }
  }

  inactivatePrevious() {
    const previous = this.DOMContainer.querySelector(".alb-nav-previous");
    if (previous) {
      previous.classList.add("inactive");
    }
  }

  onReachBeginning() {
    if (this.options.albSlideOnlyOnePage) {
      this.inactivatePrevious();
    } else {
      this.addPage(this.getSlideIndexOfCurrentSlide() - 1, false)
        .then(() => {
          this.swiper.update();
        })
        .catch(() => {
          this.inactivatePrevious();
        });
    }
  }

  onReachEnd() {
    if (this.options.albSlideOnlyOnePage) {
      this.inactivateNext();
    } else {
      this.addPage(this.getSlideIndexOfCurrentSlide() + 1, true)
        .then(() => {
          this.swiper.update();
        })
        .catch(() => {
          this.inactivateNext();
        });
    }
  }

  //cleanup

  cleanupFront() {
    const currentSlide = this.getSlideIndexOfCurrentSlide();
    const slideBefore = this.swiper.slides[this.swiper.activeIndex - 1];
    if (slideBefore && $(slideBefore).data("sliden") !== currentSlide) {
      return;
    }
    const slides = this.swiper.slides;
    for (let i = 0; i < slides.length; i++) {
      const page = slides[i].getAttribute("data-sliden");
      if (page < currentSlide) {
        this.swiper.removeSlide(0);
        const contentID = slides[i].getAttribute("data-contentid");
        const contentIDIndex = this.currentContentIDs.indexOf(contentID);
        if (contentIDIndex > -1) {
          this.currentContentIDs.splice(contentIDIndex, 1);
        }
      } else {
        break;
      }
    }
  }

  cleanupEnd() {
    const currentSlide = this.getSlideIndexOfCurrentSlide();
    const slideAfter = this.swiper.slides[this.swiper.activeIndex + 1];
    if (slideAfter && $(slideAfter).data("sliden") !== currentSlide) {
      return;
    }
    const slides = this.swiper.slides;
    for (let i = slides.length - 1; i >= 0; i--) {
      const page = slides[i].getAttribute("data-sliden");
      if (page > currentSlide) {
        this.swiper.removeSlide(this.swiper.slides.length - 1);
        const contentIDIndex = this.currentContentIDs.indexOf(
          slides[i].getAttribute("data-contentid")
        );
        if (contentIDIndex > -1) {
          this.currentContentIDs.splice(contentIDIndex, 1);
        }
      } else {
        break;
      }
    }
  }

  show() {
    this.appState.articleLightBoxDisplayed = true;
    this.DOMContainer.classList.remove("hidden");
    this.checkScrolling();
    this.appState.triggerEvent(OPENED_ALB);
    document.addEventListener("keyup", this._onEscapeButtonKeyUp);
    this.appState.trigger("appState:articleLightboxOpened");
  }

  hide() {
    this.trigger("albController:closeAlb");
    if (!this.DOMContainer.classList.contains("hidden")) {
      if (this.appState.authorized) {
        this.swiper.removeAllSlides();
        this.currentContentIDs = [];
        this.DOMContainer.classList.add("hidden");
        this.appState.contentid = undefined;
        this.appState.articleLightBoxDisplayed = false;
        this.lastIndex = null;
        this.appState.trigger("appState:articleLightboxClosed");
        this.appState.trigger("appState:openOrPageTurned");
        this.appState.triggerEvent(CLOSED_ALB);
        document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
      }
    }
  }

  destroy() {
    this.detatchClickHandlers();
    this.swiper.destroy();
    this.data = null;
    this.options = null;
    this.DOMContainer = null;
    this.albPages = [];
    this.currentContentIDs = [];
    document.documentElement.removeAttribute("style");
  }

  detatchClickHandlers() {
    const back = this.DOMContainer.querySelector(".alb-nav-back");
    if (back) {
      back.removeEventListener("click", this.back);
    }
    if (this.options.increaseFontSizeEnabled) {
      const font = this.DOMContainer.querySelector(".alb-nav-size");
      if (font) {
        font.removeEventListener("click", this.font);
      }
    }
    const prev = this.DOMContainer.querySelector(".alb-nav-previous");
    if (prev) {
      prev.removeEventListener("click", this.slideToPrev);
    }
    const next = this.DOMContainer.querySelector(".alb-nav-next");
    if (next) {
      next.removeEventListener("click", this.slideToNext);
    }
    if (this.options.extraButtonOnSlider) {
      const button = this.DOMContainer.querySelector(
        ".alb-overall-extra-button-container"
      );
      if (button) {
        button.removeEventListener("click", this.extraButtonClicked);
      }
    }
    if (this.options.sharingEnabled) {
      const share = this.DOMContainer.querySelector(".alb-nav-share");
      if (share) {
        share.removeEventListener("click", this.shareClicked);
      }
    }

    //if clicked outside alb on overlay -> go out of alb
    const overlay = this.DOMContainer.querySelector(".alb-container");
    if (overlay) {
      overlay.removeEventListener("click", this.onOverlayClicked);
    }

    this.appState.off("appState:contentIdChanged", this.setContentId);
    if (this.appState.analyticsManager.cmpManager) {
      this.appState.analyticsManager.cmpManager.off(
        "userConsent:changed",
        this.updateSharing
      );
    }
  }

  checkScrolling() {
    if (this.appState.isDesktop && !this.scrollingChecked) {
      this.scrollingChecked = true;
      const scroll = document.querySelector(".alb-content-scroll");
      const inner = document.querySelector(".alb-content");
      const difference =
        scroll.getBoundingClientRect().width -
        inner.getBoundingClientRect().width;
      if (difference > 0) {
        this.DOMContainer.classList.add("scrollbarVisible");
        //set class 'scrollbar' to document.query ('.alb')
      }
    }
  }

  _onEscapeButtonKeyUp = (e) => {
    const isImageViewerOpen = document
      .querySelector("#imageviewer")
      .classList.contains("hidden");
    if (isImageViewerOpen) {
      if (e.keyCode === 27) {
        this.hide();
      }
    }
  };

  _toggleSwiperKeyboardControl() {
    this.appState.on("imageGallery:opened", () => {
      this.swiper.disableKeyboardControl();
    });

    this.appState.on("imageGallery:closed", () => {
      this.swiper.enableKeyboardControl();
    });
  }

  showSocialSharing() {
    if (this.appState.analyticsManager.cmpManager) {
      return (
        this.appState.analyticsManager.cmpManager &&
        this.appState.analyticsManager.cmpManager.isSocialSharingTrackingEnabled()
      );
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/articleLightbox/albController.js